export default {
  PLACEHOLDER_SELECT_ADDRESS: 'Please select an address',
  INVOICES_MY_INVOICES: 'My Invoices',
  INVOICES_INVOICES_PURCHASE_HISTORY: 'Invoices / Purchase history',
  INVOICES_NO_INVOICES_FOUND: 'No invoices were found.',
  INVOICES_ORDER_NUMBER: 'Order No.',
  INVOICES_INVOICE_DATE: 'Invoice Date',
  INVOICES_PAYMENT_METHOD: 'Payment Method',
  INVOICES_PRICES: 'Price',
  INVOICES_DOWNLOAD: 'Download',
  INVOICES_PER_PAGE: '/ page',
  PAYMENT_METHOD_CREDIT_CARD: 'Credit Card',
  PAYMENT_METHOD_ADVANCED_PAYMENT: 'Advanced Payment / Pro forma',
  CHECKOUT_DELIVER_TO: 'Delivery to:',
  CHECKOUT_BILLING_TO: 'Bill to:',
  CHECKOUT_SAMPLE_COPIES_ADDRESS: 'Samples Delivery Address',
  CARD_ITEM_BUTTON_SAMPLE_COPIES: 'Label Samples',
  CUSTOMER_SERVICE_TITLE: 'Customer Service',
  CUSTOMER_SERVICE_CONTACT: 'Contact Us',
  CUSTOMER_SERVICE_AVAILABLE_FROM: 'Available from',
  CUSTOMER_SERVICE_AVAILABLE_UNTIL: 'Available until',
  CHANGE_PW_TITLE: 'Your password must be changed.',
  CHANGE_PW_CHANGE: 'Update credentials',
  CHANGE_PW_CURRENT_PW: 'Current password*',
  CHANGE_PW_NEW_PW: 'New password*',
  CHANGE_PW_REPEAT_PW: 'Repeat new password*',
  CHANGE_PW_EMAIL_MISMATCH: "Email doesn't match with current logged in user.",

  ASSERT_FIELD_REQUIRED: 'This field is required',
  ASSERT_MINIMUM_LENGTH: 'Minimum number of characters:',
  ASSERT_MAXIMUM_LENGTH: 'Maximum number of characters:',
  ASSERT_BOTH_FIELDS_MUST_BE_EQUAL: 'Both fields must match',
  ASSERT_INVALID_EMAIL: 'Please enter a valid email address',
  ASSERT_INVALID_PASSWORD:
    'Your password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number and one special character',

  AWS_COGNITO_ERROR_ATTEMPT_LIMIT: 'Too many attempts. Please try again later.',
  AWS_COGNITO_ERROR_USER_NOT_CONFIRMED:
    'Your account has not been confirmed yet. Please click the link in the confirmation email we sent you.',
  AWS_COGNITO_ERROR_PASSWORD_RESET_REQUIRED: 'You need to reset your password before logging in.',
  AWS_COGNITO_ERROR_NETWORK: "We couldn't connect to the login service. Please try again shortly.",
  AWS_COGNITO_ERROR_TOO_MANY_REQUESTS: 'Our service is currently experiencing high demand. Please try again shortly.',
  AWS_COGNITO_ERROR_LIMIT_EXCEEDED:
    'Too many requests for this account. Please wait a few minutes before trying again.',
  AWS_COGNITO_ERROR_SESSION_EXPIRED: 'Your session has expired. Please log in again using your temporary password.',

  LOGIN_EMAIL: 'Email address*',
  LOGIN_PASSWORD: 'Password*',
  LOGIN_LOGIN: 'Log in',
  LOGIN_FORGOT_PASSWORD: 'Reset password',

  FORGOT_PASSWORD_CODE_SENT: "If the email address is registered, you'll receive a password reset code shortly.",
  FORGOT_PASSWORD_INVALID_CODE: 'Invalid verification code provided, please try again.',
  FORGOT_PASSWORD_SEND_CODE: 'Send reset code',
  FORGOT_PASSWORD_EMAIL: 'Email address*',
  FORGOT_PASSWORD_RESET_CODE: 'Reset code*',
  FORGOT_PASSWORD_NEW_PASSWORD: 'New password*',
  FORGOT_PASSWORD_REPEAT_NEW_PASSWORD: 'Repeat new password*',
  FORGOT_PASSWORD_BACK_TO_LOGIN: 'Back to login',
  FORGOT_PASSWORD_RESET_PASSWORD: 'Reset password',
  FORGOT_PASSWORD_CODE_RESENT: "If the email address is registered, you'll receive a password reset code shortly..",
  FORGOT_PASSWORD_HINTS_TITLE: "Haven't received the email?",
  FORGOT_PASSWORD_HINT_SPAM: 'Check your spam or junk folder',
  FORGOT_PASSWORD_HINT_EMAIL: "Make sure you've entered the correct email address",
  FORGOT_PASSWORD_CHANGE_EMAIL: 'Change email address',
  FORGOT_PASSWORD_HINT_RESEND: 'Resend reset code',
  LOGIN_RESEND_CONFIRMATION: 'Resend confirmation email',
  LOGIN_RESEND_CONFIRMATION_SUCCESS: 'A new confirmation email has been sent.',
  LOGIN_RESEND_CONFIRMATION_ERROR: "We couldn't send the confirmation email. Please try again later.",
  SHOW_PASSWORD: 'Show password',
  HIDE_PASSWORD: 'Hide password',

  MODAL_OK: 'OK',
  MODAL_CANCEL: 'Cancel',
  MODAL_DUPLICATE_FILE_TITLE: 'Duplicate files found',
  MODAL_DUPLICATE_FILE_DESCRIPTION: 'The following file has already been uploaded:',

  PLUS_MATERIAL_HINT: 'Suitable for ice bucket immersion',
  LOADING_DATA_ISSUE_JOB: 'Please wait while we fetch your job configurations...',
  SHOW_UNIT_COUNT: 'Show unit count',
  LOT: 'LOT (Optional)',
  LINE_1: 'line 1',
  LINE_2: 'line 2',
  LINE_3: 'line 3',
  LINE_4: 'line 4',
  PROOFING_SERVICE: 'Proofing service',

  ORDER_TEMPLATES_TITLE: 'Order Templates',
  ORDER_TEMPLATES_SELECT: 'Selected order template',
  ORDER_TEMPLATES_SELECT_PLACEHOLDER: 'Please select an order template',
  ORDER_TEMPLATES_NO_TEMPLATES: 'There are no order templates available.',

  PRODUCTION_TYPE_STANDARD: 'Standard',
  PRODUCTION_TYPE_EXPRESS: '48h Express',
  PRODUCTION_TYPE_SUPER_EXPRESS: '24h Super Express',
  PRODUCTION_TYPE_ESTIMATED_SHIPPING_DATE: 'Estimated shipping date',
  PRODUCTION_TYPE_SHIPPING_DATE: 'Shipping date',
  PRODUCTION_TYPE_NOT_POSSIBLE: 'Not possible',

  SHOW_PRICE_IN_CURRENCY: 'Show prices in {currency}',
  CURRENCY_SWITCH_DISABLED_CART_NOT_EMPTY: 'You can’t change the currency while there are items in your basket.',
  CART_MIXED_CURRENCY_WARNING:
    'Your cart contains items in different currencies. Please remove the items in a different currency before checking out.',
  CHECKOUT_USER_DISABLED: 'Your account is not permitted to place orders. Please contact our customer service.',
  DESIGN_SERVICE_CURRENCY_DISABLED: 'Design Service can only be ordered in {currency}.',
  PACKAGE_ORDER_CURRENCY_DISABLED: 'This package can only be ordered in {currency}.',
  CHANGE_CURRENCY_CALCULATOR: 'Please change the currency in the homepage calculator first.',

  CART_ITEM_DISCOUNT_NOT_APPLICABLE: 'No customer discount will be given on this item due to custom pricing.',
  UPLOAD_SORTS_CONFIG_NOT_SAVED:
    'Your sort configuration could not be saved. Please check that the quantities of all sorts add up to the total quantity and try again.',
  HPI_WHITE: 'HPI-white',
  YES: 'Yes',
  NO: 'No',

  UPS_STANDARD_SHIPPING: 'UPS Standard',
  UPS_EXPRESS_SHIPPING: 'UPS Express Saver',
  UPS_STANDARD_SHIPPING_NEUTRAL: 'UPS Standard – Carbon Offset Shipping',
  UPS_EXPRESS_SHIPPING_NEUTRAL: 'UPS Express Saver – Carbon Offset Shipping'
} as const
